import React from 'react';

import {MeasurementType, NewMeasurementForm} from 'samples/MeasurementForm';
import {BaseFilterFormProps, FilterStyle} from 'search/filters/base/FilterFormConstants';
import OperatorDropdown from 'search/filters/base/OperatorDropdown';
import SecondaryFilterFormSkeleton from 'search/filters/base/SecondaryFilterFormSkeleton';
import {ContainerConcentrationFilter, Operator} from 'search/SearchConstants';
import {NumericInputChangeEvent} from 'util/Types';

export interface ContainerConcentrationFilterFormProps extends BaseFilterFormProps {
  filter: ContainerConcentrationFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: ContainerConcentrationFilter) => void;
  onEnter?: () => void;
  operators: Array<Operator>;
  onRemove: () => void;
}

export default function ContainerConcentrationFilterForm(
  props: ContainerConcentrationFilterFormProps
): JSX.Element {
  const measurementFormSharedProps = {
    measurement: props.filter.value,
    onChangeUnits: ({val: units}: {val: string | null}) => {
      props.onChangeFilter({...props.filter, value: {...props.filter.value, units}});
    },
    onChangeValue: ({target: {numericValue: value}}: NumericInputChangeEvent) => {
      props.onChangeFilter({...props.filter, value: {...props.filter.value, value}});
    },
    onEnter: props.onEnter,
  };
  const measurementInput = (
    <NewMeasurementForm {...measurementFormSharedProps} measurementType={MeasurementType.CONCENTRATION} />
  );

  return (
    <SecondaryFilterFormSkeleton
      {...props}
      nodeGrid={[
        [
          <OperatorDropdown
            buttonSize={props.buttonSize}
            onChangeOperator={(operator) => {
              props.onChangeFilter({...props.filter, operator});
            }}
            operators={props.operators}
            selectedOperator={props.filter.operator}
          />,
        ],
        [measurementInput],
      ]}
      onChangeFilterKey={props.onChangeFilterKey}
      selectedFilterKey={props.selectedFilterKey}
      onRemove={props.onRemove}
    />
  );
}
